import { connect } from 'react-redux'
import CrowdfundingDetailView from 'components/crowdfunding_detail_view'
import { getCampaignSelector } from 'redux/selectors/campaign'
import { getCategoryDefaultCover, getMainCategory } from 'client/lib/category'
import { clearDNWTransactionError } from 'redux/modules/dnw_transaction'

const mapStateToProps = (state, ownProps) => {
  const campaign = getCampaignSelector(state, ownProps)
  const mainCategory = getMainCategory(campaign.category)
  const defaultCategoryCover = getCategoryDefaultCover(state, mainCategory)
  const isLoadingDNWTransaction = state.dnw_transaction.isLoading
  const countryCode = campaign.country_code
  const geo = state.geo
  const isMobile = state.device_info.isMobile
  const paymentsTokenError = state.dnw_transaction.error

  return {
    defaultCategoryCover,
    campaign,
    isLoadingDNWTransaction,
    countryCode,
    geo,
    isMobile,
    paymentsTokenError,
  }
}
const mapDispatchToProps = {
  clearDNWTransactionError,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CrowdfundingDetailView)
